// extracted by mini-css-extract-plugin
export var numpadContainer = "_jb-1";
export var phoneButton = "_jb-0";